/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ToolPencilLineIcon20Solid = forwardRef('ToolPencilLineIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M2 14.414V16.5a.5.5 0 0 0 .5.5h2.086a1 1 0 0 0 .707-.293l8.145-8.145-3-3-8.145 8.145a1 1 0 0 0-.293.707Z" }),
        React.createElement("path", { d: "m15.58 6.42-1.07 1.07-3-3 1.07-1.07a1.3 1.3 0 0 1 1.84 0l1.16 1.16a1.3 1.3 0 0 1 0 1.84Z" }),
        React.createElement("path", { d: "M10.007 15a1 1 0 0 0 0 2H17a1 1 0 1 0 0-2h-6.993Z" })));
});
